import { render, staticRenderFns } from "./Monitor-invoce.vue?vue&type=template&id=5a8ff82b&scoped=true"
import script from "./Monitor-invoce.vue?vue&type=script&lang=js"
export * from "./Monitor-invoce.vue?vue&type=script&lang=js"
import style0 from "./Monitor-invoce.vue?vue&type=style&index=0&id=5a8ff82b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a8ff82b",
  null
  
)

export default component.exports